<template>
  <div>
    <span class="chart-header">
      <h3>{{title}}</h3>
      <p>{{subtitle}}</p>
    </span>
    <bar-chart :chart-data="datacollection" v-if="datacollection !== null"></bar-chart>
  </div>
</template>

<script>
  import BarChart from './BarChart.js'

  export default {
    components: {
      BarChart
    },
    data () {
      return {
      }
    },
    props: {
      datacollection: Object,
      title: String,
      subtitle: String,
    }
  }
</script>

<style lang="scss" scoped>

.chart-header{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1em;
}

</style>